export const fieldSpacing = '20px'

export const inputFieldCss = `
  width: 100%;
  height: 100%;
  padding-left: 14px;
  padding-right: 14px;
`
